import { Typography, Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";

//photo
import amozesh1 from "../../assetes/Amozesh/Amozesh-1.JPG";
import amozesh2 from "../../assetes/Amozesh/Amozesh-2.JPG";
import amozesh3 from "../../assetes/Amozesh/Amozesh-3.JPG";
import { Stack } from "react-bootstrap";

const Amozesh = () => {
  return (
    <>
      <Box sx={{ paddingLeft: 2 }}>
        <Typography variant="h2" sx={{ fontSize: "2rem", margin: 2 }}>
          واحد آموزش
        </Typography>
        <Typography
          sx={{
            fontSize: "1.2rem",
            margin: 2,
            mb: 3,
            padding: 1,
            textAlign: "center",
          }}
        >
          در راستای اعتلا و ارتقا دانش فنی کارشناسان در صنایع گوناگون ، گروه
          صنعتی ایما با همکاری انجمن صنفی خدمات مهندسی ، دوره های آموزشی تخصصی
          کوتاه مدت در زمینه و حیطه فعالیت خود برگزار می نماید . جهت اطلاع از
          لیست دوره ها و ثبت نام با شرکت تماس حاصل فرمایید.
        </Typography>
        <Grid
          spacing={2}
          container
          sx={{ display: "flex", justifyContent: "space-around" }}
        >
          <Grid xs={12} sm={12} md={4} spacing={2} sx={{ xs: "block" }}>
            <img
              alt="آموزش"
              src={amozesh1}
              style={{ width: "95%", borderRadius: "7px" }}
            ></img>
          </Grid>
          <Grid xs={12} sm={12} md={4} spacing={2}>
            <img
              alt="آموزش"
              src={amozesh2}
              style={{ width: "95%", borderRadius: "7px" }}
            ></img>
          </Grid>
          <Grid xs={12} sm={12} md={4} spacing={2}>
            <img
              alt="آموزش"
              src={amozesh3}
              style={{ width: "95%", borderRadius: "7px" }}
            ></img>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
export default Amozesh;
